import { createActions } from 'redux-actions';
import types from './types';

const {
  addMessage,
  addChat,
  editMessage,
  removeMessage,
  addMessages,
  changeActiveChat,
  setNewMessage,
  clearNewMessage,
  clearMessenger,
  changeChatAttr,
  setChannelsSorted,
  changeUserOnlineStatus,
  clearChat,
} = createActions(
  types.ADD_MESSAGE,
  types.ADD_CHAT,
  types.EDIT_MESSAGE,
  types.REMOVE_MESSAGE,
  types.ADD_MESSAGES,
  types.CHANGE_ACTIVE_CHAT,
  types.SET_NEW_MESSAGE,
  types.CLEAR_NEW_MESSAGE,
  types.CLEAR_MESSENGER,
  types.CHANGE_CHAT_ATTR,
  types.SET_CHANNELS_SORTED,
  types.CHANGE_USER_ONLINE_STATUS,
  types.CLEAR_CHAT,
);

export default {
  addChat,
  addMessage,
  editMessage,
  removeMessage,
  addMessages,
  changeActiveChat,
  setNewMessage,
  clearNewMessage,
  clearMessenger,
  changeChatAttr,
  setChannelsSorted,
  changeUserOnlineStatus,
  clearChat,
};



// WEBPACK FOOTER //
// ./src/reducers/messages/actions.js